import { Component, input, output, signal } from '@angular/core';

@Component({
  selector: 'app-report-error-card',
  templateUrl: './report-error-card.component.html',
  styleUrl: './report-error-card.component.scss'
})
export class ReportErrorCardComponent {
  title = input<string>('No se pudo cargar el reporte');
  message = input<string>('');
  isRetrying = input<boolean>(false);

  isClosing = signal(false);

  retry = output<void>();
  cleared = output<void>();

  close(): void {
    this.isClosing.set(true);
    setTimeout(() => {
      this.isClosing.set(false);
      this.cleared.emit();
    }, 250);
  }
}
